// extracted by mini-css-extract-plugin
export default {"emailFormWrapper":"MCL791e9adV9UycHuFhZ","title":"NsCwQ5_su2rIEg0ywBlp"};